import React, { } from "react";
import {
  Routes,
  Route,
  HashRouter,
  Navigate,
} from "react-router-dom";
import Loading from "../pages/Loading";
import HomeScreen from "../pages/HomeScreen";
// import InfoScreen from "./../pages/InfoScreen"
import ConditionScreen from "./../pages/ConditionScreen"
import OnboardingScreen from "./../pages/OnboardingScreen"
import OverviewScreen from "../pages/OverviewScreen";
import DocScreen from "../pages/DocScreen";
import CheckScreen from "../pages/CheckScreen";
import VerificaMobile from "../pages/VerificaMobile";
import CheckOperatore from "../pages/CheckOperatore";
import VistaAggiuntivaScreen from "../pages/VistaAggiuntivaScreen";
import HomeScreenOperatore from "../pages/HomeScreenOperatore";
import SetIsTotem from "../pages/SetIsTotem";
import CompleteScreen from "../pages/CompleteScreen";

const MainRoutes = () => {
  return (
    <HashRouter>
      <Routes>
        <Route
          path="/homepage"
          element={
            <HomeScreen />
          }
        />
        {/* <Route
          path="/info"
          element={
            <InfoScreen />
          }
        /> */}
        <Route
          path="/conditions"
          element={
            <ConditionScreen />
          }
        />
        {/* <Route
          path="/vista"
          element={
            <VistaAggiuntivaScreen />
          }
        /> */}
        <Route
          path="/onboarding"
          element={
            <OnboardingScreen />
          }
        />
        <Route
          path="/overview"
          element={
            <OverviewScreen />
          }
        />
        <Route
          path="/documenti"
          element={
            <DocScreen />
          }
        />
        <Route
          path="/loading"
          element={
            <VerificaMobile />
          }
        />
        {/* <Route
          path="/check"
          element={
            <CheckScreen />
          }
        /> */}
        <Route
          path="/access/:token"
          element={
            <CheckScreen />
          }
        />

        <Route
          path="/operatore/:token"
          element={
            <CheckOperatore />
          }
        />
        <Route
          path="/home"
          element={
            <HomeScreenOperatore />
          }
        />
        <Route
          path="/totem"
          element={
            <SetIsTotem />
          }
        />
        <Route
          path="/completa"
          element={
            <CompleteScreen />
          }
        />
        <Route path="/" element={<Loading />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
};

export default MainRoutes;
